module.exports = __webpack_public_path__ + "static/img/three.c271841.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newVcard/three.jpg
// module id = 4Y1c
// module chunks = 1